module.exports = __webpack_public_path__ + "static/media/NarendiranPillay.82c5b8fc.png";